import api from './client';
import type {
  RegisterTokenRequest,
  RegisterTokenResponse,
  UnregisterTokenRequest,
  UnregisterTokenResponse,
  SendNotificationRequest,
  SendNotificationResponse,
  ListTokensResponse,
} from './types';

export const pushNotificationsApi = {
  /**
   * Register a new FCM token for the authenticated user
   * @param request - Token registration data
   */
  registerToken: async (request: RegisterTokenRequest): Promise<RegisterTokenResponse> => {
    const { data } = await api.post('/push/register', request);
    return data;
  },

  /**
   * Unregister (delete) an FCM token for the authenticated user
   * @param request - Token unregistration data
   */
  unregisterToken: async (request: UnregisterTokenRequest): Promise<UnregisterTokenResponse> => {
    const { data } = await api.post('/push/unregister', request);
    return data;
  },

  /**
   * Get list of user's registered tokens
   */
  listTokens: async (): Promise<ListTokensResponse> => {
    const { data } = await api.get('/push/tokens');
    return data;
  },

  /**
   * Send push notification to specific users or tokens
   * Note: Not recommended for direct use. Prefer using backend endpoints.
   * @param request - Send notification request
   */
  send: async (request: SendNotificationRequest): Promise<SendNotificationResponse> => {
    const { data } = await api.post('/push/send', request);
    return data;
  },
};
